"use client";

import React from "react";

import RichText from "@/components/atoms/rich-text/rich-text";
import { TextButton } from "@/components/molecules/cta-button/cta-buttons";

interface PartialMedicalDeclineModalContentProps {
  title?: string;
  description?: string;
  ctaButtonLabel?: string;
  onContinue?: () => void;
}

function PartialMedicalDeclineModalContent({
  title = "Your available covers",
  description = `<p>Here are the cover options currently available to you, based on your details. </p>`,
  ctaButtonLabel = "See cover options",
  onContinue,
}: Readonly<PartialMedicalDeclineModalContentProps>) {
  return (
    <div className="flex flex-col">
      <h1
        className="text-text-title font-dmserif font-header-font text-m md:text-3xl sm:text-[23px] sm:leading-custom-size-compact text-center
            md:leading-custom-size-xl md:mb-spacing-s mb-spacing-xs"
      >
        {title}
      </h1>

      <div className="leading-custom-size-lg text-text-body sm:text-2xs-font-size mb-spacing-l">
        <RichText
          richText={description}
          className="leading-normal text-text-body text-xs text-center space-y-[9px]"
        />
      </div>

      <div className="flex md:flex-row flex-col gap-x-spacing-xs">
        <TextButton
          hierarchy="primary"
          label={ctaButtonLabel}
          onClick={onContinue}
          className="!h-[48px] lg:w-[474px] md:w-[330px] w-full !text-confirmation-body leading-[18px]"
        />
      </div>
    </div>
  );
}

export default PartialMedicalDeclineModalContent;
